import { getData as apiGetData } from 'api/Api'
import {
  addArray
} from '../redux/cards'
import {
  setArray as setDescendantBlockedCardArray
} from 'store/redux/descendantBlockedCards'
import {
  setArray as setPreviousBlockedCardArray
} from 'store/redux/previousBlockedCards'

type Payload = {
  cardIds: number[];
}

const fetchCardOverlay = (payload: Payload) => async (dispatch, getState) => {
  const { cardIds } = payload

  const getDataPromise = apiGetData('CardsOverlays', {
    cardIds,
    fields: [
      'CardBlockersCount',
      'DescendantBlockedCards',
      'PreviousBlockedCards',
      'AncestorsCardsDates',
      'DescendantCardsDates',
      'SequenceCardsDates',
    ]
  })

  const getDataResult = await Promise.race<any>([
    getDataPromise,
    new Promise((_, reject) => setTimeout(reject, 30000)),
  ]).catch(() => getDataPromise.cancel())

  if (getDataResult) {
    const { Cards } = getDataResult

    dispatch([
      addArray(Cards.map(Card => ({
        id: Card.Id,
        blockerCount: Card.CardBlockersCount,
        ancestorCardsDates: Card.AncestorsCardsDates.map(AncestorCard => ({
          id: AncestorCard.Id,
          startDate: AncestorCard.StartDate,
          dueDate: AncestorCard.DueDate
        })),
        descendantCardsDates: Card.DescendantCardsDates.map(DescendantCard => ({
          id: DescendantCard.Id,
          startDate: DescendantCard.StartDate,
          dueDate: DescendantCard.DueDate
        })),
        prevCardDates: Card.SequenceCardsDates.Prev.map(PrevCard => ({
          id: PrevCard.Id,
          startDate: PrevCard.StartDate,
          dueDate: PrevCard.DueDate
        })),
        nextCardDates: Card.SequenceCardsDates.Next.map(NextCard => ({
          id: NextCard.Id,
          startDate: NextCard.StartDate,
          dueDate: NextCard.DueDate
        })),
      }))),
      ...Cards.map(Card => setDescendantBlockedCardArray({
        cardId: Card.Id,
        descendantCardIds: Card.DescendantBlockedCards
      })),
      ...Cards.map(Card => setPreviousBlockedCardArray({
        cardId: Card.Id,
        previousCardIds: Card.PreviousBlockedCards
      })),
    ])
  }
}

export default fetchCardOverlay
